import {getSafeEventDate} from './dateTimeUtils';
import moment from 'moment';
import branch from 'branch-sdk';

branch.init('key_live_moaUSFTe8vq7Y3eMwl71znldqAb61Rbi', function(err, data) {
   // callback to handle err or data
});

export function createEventDeepLink(event, deeplinkRowId) {
   return new Promise(function (resolve, reject) {
      let myEvent = modifyEventObject(event);
      let linkData = createLinkData(myEvent, deeplinkRowId);
      branch.link(linkData,
         function(err, result){
            if (err) {
               reject(err);
            } else {
               resolve(result);
            }
         }
      );
   });
}

function modifyEventObject(event) {
   let myEvent = Object.assign({}, event);

   myEvent.allowedUsers = []; // for performace & easy debugging
   myEvent.usersDetails = []; // for performace & easy debugging
   myEvent.usersJoinedEvent = []; // for performace & easy debugging

   // edit cloudinary url to be of maximum height of 200, and to be jpg:
   myEvent.picUrl = myEvent.picUrl.replace(".png", ".jpg"); // note, TODO, it will fail once in several thousands since png might appear randomly in the string
   myEvent.picUrl = myEvent.picUrl.replace(".PNG", ".jpg"); // note, TODO, it will fail once in several thousands since png might appear randomly in the string
   myEvent.picUrl = myEvent.picUrl.replace("image/upload/", "image/upload/c_scale,h_200/");

   // fix format for date
   myEvent.date = getSafeEventDate(myEvent.date);
   myEvent.dateHTML = moment(myEvent.date).format("MMM Do YYYY, HH:mm");
   let tempDate = myEvent.dateHTML.split(",");
   myEvent.dateOnlyHTML = tempDate[0];
   myEvent.timeOnlyHTML = tempDate[1];
   return myEvent;
}

function createLinkData(event, deeplinkRowId) {
   let og_description =  "Plan music for your event, " + event.dj_name;
   let linkData = {
      contentMetadata : {
         "id": event.objectId,
         "deeplinkObjectId": deeplinkRowId, // the object id in parse of the special permissions grant row in the Deeplink table in Parse
         "linkUniqueId": getRandId(),
         "creationDate": (new Date()).toISOString(),
         "myEvent": event,
         "myEvent_title" : event.title,
         "myEvent_picUrl" : event.picUrl,
         "myEvent_dateOnlyHTML" : event.dateOnlyHTML,
         "myEvent_location" : event.location,
         "myEvent_locationWaze" : ("waze://?q=" + event.location),
         "myEvent_timeOnlyHTML" : event.timeOnlyHTML,
         "myEvent_additionalDescription" : event.additionalDescription,
         "myEvent_dj_picUrl" : event.dj_picUrl,
         "myEvent_region" : event.region,
         "$custom_sms_text" : "{{link}}",
      },
      canonicalIdentifier: 'identifier',
      title: event.title,   //'Just another title',
      contentDescription: og_description,   //'Just another description',
      contentImageUrl: event.picUrl, //needs to be jpg to work in android,
      contentIndexingMode: 'public'
   };
   if(event.eventType === "Wedding"){
      linkData.contentMetadata["$android_url"] = '';
      linkData.contentMetadata["$android_deepview"] = false;
      linkData.contentMetadata["$ios_deepview"] = false;
   }

   if(event.eventType === "Bar-Mitzvah"){
      linkData.contentMetadata["myEvent_isBarMitzvah"] = true;
   }

   if(event.eventType === "Bat-Mitzvah"){
      linkData.contentMetadata["myEvent_isBatMitzvah"] = true;
   }

   if(event.eventType === "Party"){
      linkData.contentMetadata["myEvent_isParty"] = true;
   }

   if(event.eventType === "Birthday"){
      linkData.contentMetadata["myEvent_isBirthday"] = true;
   }

   if(event.eventType === "Wedding"){
      linkData.contentMetadata["myEvent_isWedding"] = true;
   }

   if(event.isVenue){
      linkData.contentMetadata["myEvent_isVenue"] = true;
   }

   if(event.region === "en_US"){
      linkData.contentMetadata["myEvent_isEnglish"] = true;
   } else {
      linkData.contentMetadata["myEvent_isNotEnglish"] = true;
   }

   linkData.data = linkData.contentMetadata;
   linkData.data.channel = 'sms'; // might not be important
   linkData.data.feature = 'share'; // might not be importanst
   linkData.data['$og_title'] = event.title;
   linkData.data['$og_description'] = og_description;
   linkData.data['$og_image_url'] = event.picUrl;

   return linkData;
}

function getRandId() {
   var buf = new Uint8Array(16);
   window.crypto.getRandomValues(buf);
   var b64encoded = btoa(String.fromCharCode.apply(null, buf));
   b64encoded = b64encoded.substring(0, b64encoded.length - 2);
   b64encoded = b64encoded.replace(/\W/g, ''); // remove all non-alphanumeric chars
   return b64encoded;
}



// WEBPACK FOOTER //
// ./src/utils/BranchService.js